import {SRP_BUS_URL_V4,SRP_GOSAFE_URL, LOG_FE_METRIC} from './../../config/apiPoints';


export const prepareSRPApiRequest_V4 = () => {
  const url = `${__ENV_CONFIG__.__CB_HOST__}${SRP_BUS_URL_V4}`;
  return url;
};

export const prepareRedDealRequest = () => {};
export const prepareGoSafeBannerURL = () =>{
   const url = `${__ENV_CONFIG__.__VOYAGER__}${SRP_GOSAFE_URL}`

  return url;
}

export const prepareLogFeMetricRequest = () => {
  const url = `${__ENV_CONFIG__.__CB_HOST__}${LOG_FE_METRIC}`
  return url;
}